import { PureComponent } from 'react';
import { Segment, Grid } from 'semantic-ui-react';
import { HtmlService } from '../../../services';
import { isEmpty } from '../../../utils/lodash';
import { withTranslation } from 'react-i18next';

import './activity.scss';

class NotesComponent extends PureComponent {
  render() {
    const {
      isAnalysisField,
      analysis,
      reflection,
      evaluationPlans,
      isParent,
      t,
    } = this.props;
    const normalEvaluation = evaluationPlans.filter((item) => {
      return item.methodId !== 9;
    });

    return (
      <Segment className="report-activity-seg">
        <div className="report-activity-div">
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                {isAnalysisField &&
                  analysis &&
                  (isParent || !isEmpty(normalEvaluation)) && (
                    <>
                      <div className="segment-custom-heading-evidence">
                        {t('activity.notes.evaluation_results_analysis')}
                      </div>
                      <div className="info-desc info-desc-last">
                        {HtmlService.convertToInnerHtml({
                          children: analysis,
                          richText: true,
                          htmlConversionStyle: 'para',
                          returnAs: 'html',
                        })}
                      </div>
                    </>
                  )}

                <div className="segment-custom-heading-evidence">
                  {t('activity.notes.reflection')}
                </div>
                <div className="info-desc info-desc-last">
                  {HtmlService.convertToInnerHtml({
                    children: reflection || '-',
                    richText: true,
                    htmlConversionStyle: 'para',
                    returnAs: 'html',
                  })}
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Segment>
    );
  }
}

export const Notes = withTranslation()(NotesComponent);
